import { render, staticRenderFns } from "./gameNews.vue?vue&type=template&id=3383571c&scoped=true&"
import script from "./gameNews.vue?vue&type=script&lang=js&"
export * from "./gameNews.vue?vue&type=script&lang=js&"
import style0 from "./gameNews.vue?vue&type=style&index=0&id=3383571c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3383571c",
  null
  
)

export default component.exports